module.exports = __webpack_public_path__ + "img/0Q3B1666_L_Black.1b98cfc3.jpg";